import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, message, Select, InputNumber } from 'antd';
import apiRequest from '../hooks/ApiRequest';

const { Option } = Select;

const ClientDetailForm = ({ form, customerData }) => {
  debugger;
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = form;

  const [customerId, setCustomerId] = useState(null);
  const [entityTypeValue, setEntityTypeValue] = useState('Individual'); // Track entity type selection

  useEffect(() => {
    if (customerData) {
      debugger;
      setFieldsValue({
        firstName: customerData.customerName,
        lastName: customerData.customerSurname,
        email: customerData.emailAddress,
        age: customerData.age,
        nationalId: customerData.nationalID,
        gender: customerData.gender,
        address: customerData.address,
        suburb: customerData.suburb,
        city: customerData.city,
        entityType: customerData.entityType || 'Individual',
        corporateName: customerData.corporateName || '',
        contactNumber: customerData.mobile || '',
      });
    } else {
      resetFields();
    }
  }, [customerData, setFieldsValue, resetFields]);

const handleSubmit = e => {
  e.preventDefault();
  validateFields(async (err, values) => {
    if (!err) {
      try {
        if (customerId) {
          await apiRequest.put(`/customers/${customerId}`, values);
          message.success('Client details updated successfully!');
        } else {
          await apiRequest.post('/customers', values);
          message.success('Client details added successfully!');
        }
      } catch (err) {
        console.error('Error saving customer:', err);
        message.error('Failed to save client details');
      }
    }
  });
};

const handleEntityTypeChange = value => {
  setEntityTypeValue(value);
  // If user switches from Business to Individual, clear corporateName field
  if (value === 'Individual') {
    setFieldsValue({ corporateName: '' });
  }
};

return (
  <Form layout="vertical" onSubmit={handleSubmit}>
    <Row gutter={16}>
      <Col lg={8}>
        <Form.Item label="First Name">
          {getFieldDecorator('firstName', {
            rules: [{ required: true, message: 'Please enter first name' }],
          })(<Input placeholder="Enter first name" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Last Name">
          {getFieldDecorator('lastName', {
            rules: [{ required: true, message: 'Please enter last name' }],
          })(<Input placeholder="Enter last name" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Email Address">
          {getFieldDecorator('email', {
            rules: [
              { required: true, message: 'Please enter email address' },
              { type: 'email', message: 'Please enter a valid email address' },
            ],
          })(<Input placeholder="Enter email address" disabled />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Age">
          {getFieldDecorator('age', {
            rules: [
              { required: true, message: 'Please enter age' },
              { type: 'number', min: 18, max: 100, message: 'Age must be between 18 and 100' },
            ],
          })(
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Enter age"
              min={18}
              max={100}
            />
          )}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="National ID">
          {getFieldDecorator('nationalId', {
            rules: [
              { required: true, message: 'Please enter national ID' },
              { pattern: /^[A-Za-z0-9]{6,20}$/, message: 'National ID must be 6-20 alphanumeric characters' },
            ],
          })(<Input placeholder="Enter national ID" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Gender">
          {getFieldDecorator('gender', {
            rules: [{ required: true, message: 'Please select gender' }],
          })(
            <Select placeholder="Select gender">
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Other">Other</Option>
            </Select>
          )}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Address">
          {getFieldDecorator('address', {
            rules: [{ required: true, message: 'Please enter address' }],
          })(<Input placeholder="Enter address" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Suburb">
          {getFieldDecorator('suburb', {
            rules: [{ required: true, message: 'Please enter suburb' }],
          })(<Input placeholder="Enter suburb" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="City">
          {getFieldDecorator('city', {
            rules: [{ required: true, message: 'Please enter city' }],
          })(<Input placeholder="Enter city" />)}
        </Form.Item>
      </Col>

      <Col lg={8}>
        <Form.Item label="Entity Type">
          {getFieldDecorator('entityType', {
            initialValue: entityTypeValue,
            rules: [{ required: true, message: 'Please select entity type' }],
          })(
            <Select placeholder="Select entity type" onChange={handleEntityTypeChange}>
              <Option value="Individual">Individual</Option>
              <Option value="Business">Business</Option>
            </Select>
          )}
        </Form.Item>
      </Col>

      {entityTypeValue === 'Business' && (
        <Col lg={8}>
          <Form.Item label="Corporate Name">
            {getFieldDecorator('corporateName', {
              rules: [{ required: true, message: 'Please enter corporate name' }],
            })(<Input placeholder="Enter corporate name" />)}
          </Form.Item>
        </Col>
      )}

      <Col lg={8}>
        <Form.Item label="Contact Number">
          {getFieldDecorator('contactNumber', {
            rules: [
              { required: true, message: 'Please enter contact number' },
              { pattern: /^[0-9]{7,15}$/, message: 'Contact number must be 7 to 15 digits' },
            ],
          })(<Input placeholder="Enter contact number" />)}
        </Form.Item>
      </Col>

      <Col lg={24} style={{ textAlign: 'right' }}>
        <Button htmlType="submit" type="primary" className="primary m-t-22">
          Save Client Details
        </Button>
      </Col>
    </Row>
  </Form>
);
};

export default Form.create()(ClientDetailForm);
